var map = {
	"./assamese.json": [
		42074,
		74
	],
	"./bengali.json": [
		77866,
		866
	],
	"./english.json": [
		94904,
		904
	],
	"./gujarati.json": [
		23059,
		59
	],
	"./hindi.json": [
		44952,
		952
	],
	"./kannada.json": [
		25656,
		656
	],
	"./malayalam.json": [
		41307,
		307
	],
	"./marathi.json": [
		59270,
		270
	],
	"./odia.json": [
		65345,
		345
	],
	"./punjabi.json": [
		52551,
		551
	],
	"./tamil.json": [
		26683,
		683
	],
	"./telugu.json": [
		76368,
		368
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 75896;
module.exports = webpackAsyncContext;